import { Group } from '@mantine/core';
import { IconFilter, IconMessageCircle } from '@tabler/icons';
import { FC, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { useBookitupScope } from '../../../Service/Context/BookitupSubscriptionContext';
import { useConversationsWidget } from '../../../Service/Context/HubspotContext';
import { ProfileContext } from '../../../Service/Context/ProfileContext';
import ActionIconWithText from './ActionIconWithText';
import InboxIconWithIndicator from './InboxIconWithIndicator';
import ListCheckIconWithIndicator from './ListCheckIconWithIndicator';
import NavAddIcon from './NavAddIcon';

interface HandlersProps {
  filter: () => void;
  addHandler: () => void;
}

const EventsPageFooter: FC<HandlersProps> = ({ filter, addHandler }) => {
  const { openWidget } = useConversationsWidget();
  const { unreadMessagesProps } = useContext(ProfileContext);
  const { unreadCount } = unreadMessagesProps ?? { unreadCount: 0 };
  const navigate = useNavigate();
  const { isScopeSelected: hasEmailScope } = useBookitupScope('EMAILS');

  return (
    <Group px="xl" pt={5} sx={{ justifyContent: 'space-between' }}>
      <ActionIconWithText useDefaultWidth label="Filter" onClick={filter}>
        <IconFilter />
      </ActionIconWithText>
      <ActionIconWithText label="Aufgaben" onClick={() => navigate('/tasks')} useDefaultWidth>
        <ListCheckIconWithIndicator />
      </ActionIconWithText>
      <NavAddIcon onClick={addHandler} />
      {hasEmailScope ? (
        <ActionIconWithText useDefaultWidth label="Postfach" onClick={() => navigate('/postbox/inbox')}>
          <InboxIconWithIndicator unreadCount={unreadCount} />
        </ActionIconWithText>
      ) : (
        <div style={{ width: '10%' }} />
      )}
      <ActionIconWithText useDefaultWidth label="Support" onClick={openWidget}>
        <IconMessageCircle />
      </ActionIconWithText>
    </Group>
  );
};

export default EventsPageFooter;
